import React, { Component } from 'react'
import * as utils from "../../utils";
import * as common_utils from "../../../common/utils";

import LikedByModal from "./liked-by-modal";

const LikesCount = React.createClass({
  getInitialState: function() {
    return { isModalOpen: false };
  },
  render: function() {
    const { liked, likes, likedBy} = this.props;

    let likeStr = "";

    if (this.props.detailedInfo) {
      likeStr = getDetailedLikeStr(liked, likes, likedBy);
    } else {
      likeStr = `${common_utils.pluralize("Like", likes)}`
    }

    return (
      <a className={`like-count ${liked ? "liked" : ""}`} onClick={this.handleClick}>
        {likeStr}
        <LikedByModal likedBy={likedBy} isModalOpen={this.state.isModalOpen} onClose={this.handleOnClose} />
      </a>
    )
  },
  handleClick: function(e) {
    e.preventDefault();
    this.setState({
      isModalOpen: true
    });
  },
  handleOnClose: function() {
    this.setState({
      isModalOpen: false
    })
  }
})

function getDetailedLikeStr(liked, likes, likedBy) {
  if (liked) {
    if (likes === 1) {
      return "You like this";
    } else {
      return `You and ${common_utils.pluralize("other", likes - 1)} like this`;
    }
  } else {
    const firstLike = likedBy[Object.keys(likedBy)[0]];
    if (likes === 1) {
      return `${firstLike.first_name} ${firstLike.last_name} likes this`;
    } else {
      return `${firstLike.first_name} ${firstLike.last_name} & ${common_utils.pluralize("other", likes - 1)} like this`
    }
  }
}

export default LikesCount;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/posts/components/likes-count.es6